module.exports = __webpack_public_path__ + "img/guide.11f276b1.png";